import { useEffect, useState, useRef } from "react";
import Web3 from "web3";
import { useWeb3React } from "@web3-react/core";
import { getWeb3NoAccount, setFallbackChainId } from "../utils/web3";

const useWeb3 = () => {
  const { provider, connector } = useWeb3React();
  const refProvider = useRef(provider);
  const [web3, setWeb3] = useState(
    provider ? new Web3(connector.provider) : getWeb3NoAccount()
  );

  useEffect(() => {
    if (provider !== refProvider.current) {
      const newWeb3 = provider
        ? new Web3(connector.provider)
        : getWeb3NoAccount();

      setWeb3(newWeb3);
      refProvider.current = provider;
    }
  }, [provider, connector]);

  // Fallback web3 instance when wallet not connected
  useEffect(() => {
    if (!provider) {
      setWeb3(getWeb3NoAccount());
    }
  }, [provider]);

  return web3;
};

export default useWeb3;
